import React from 'react';
import ReactECharts from 'echarts-for-react';

const CCSCostFullChart = ({ design1Cost, design2Cost, design1title, design2title }) => {

  if (!design1Cost.length || !design2Cost.length) {
    return <div>Loading...</div>; // Or any other loading indicator
  }
  
  // Assuming design1Cost and design2Cost are 3D arrays with shape (iterations, periods, features)
  const analysisPeriod = design1Cost[0].length;
  const X = Array.from({ length: analysisPeriod }, (_, i) => i + 1);

  // Calculate cumulative sums for each design
  const CostCumsum1 = design1Cost.map(iteration => iteration.map(period => period.reduce((acc, val) => acc + val, 0) / 1e6));
  const CostCumsum2 = design2Cost.map(iteration => iteration.map(period => period.reduce((acc, val) => acc + val, 0) / 1e6));

  // Calculate savings
  const CostSaving = CostCumsum2.map((cumsum2, idx) => cumsum2.map((val, periodIdx) => val - CostCumsum1[idx][periodIdx]));

  // Calculate median, upper, lower percentiles
  const savingMedian = Array.from({ length: analysisPeriod }, (_, i) =>
    CostSaving.map(row => row[i]).sort((a, b) => a - b)[Math.floor(CostSaving.length / 2)]
  );

  const savingUp = Array.from({ length: analysisPeriod }, (_, i) =>
    CostSaving.map(row => row[i]).sort((a, b) => a - b)[Math.floor(CostSaving.length * 0.975)]
  );

  const savingLow = Array.from({ length: analysisPeriod }, (_, i) =>
    CostSaving.map(row => row[i]).sort((a, b) => a - b)[Math.floor(CostSaving.length * 0.025)]
  );

  const saving95 = Array.from({ length: analysisPeriod }, (_, i) =>
    CostSaving.map(row => row[i]).sort((a, b) => a - b)[Math.floor(CostSaving.length * 0.95)]
  );

  // ECharts configuration
  const option = {
    title: {
      text: `Cost (${design2title}) - Cost (${design1title})`,
      left: 'center',
    },
    xAxis: {
      type: 'category',
      data: X,
      name: 'Analysis Period (Years)',
      nameLocation: 'middle',
      nameGap: 30,
          // Custom ticks to display
          axisTick: {
              show: false,
              interval: 5, // Ensure all ticks are shown
          },
          min: 0, // Set minimum value for x-axis
          max: 50, // Set maximum value for x-axis
          // Set the tick values explicitly
          axisLabel: {
              formatter: function (value) {
                  // Create custom ticks: 1, 5, 10, 15, ..., 50
                  const customTicks = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
                  return customTicks.includes(parseInt(value)) ? value : '';
              },
              interval: 0 // This will ensure every label is checked for formatting
          },
      },
    yAxis: {
        type: 'value',
        axisLine: {
            show: true, // Show the axis line with default color
        },
        axisTick: {
            show: true, // Show tick marks with default style
        },
      name: 'Cumulative Cost (M.$)',
      nameLocation: 'middle',
      nameGap: 30,
    },
    grid: {
      left: '10%',
      right: '10%',
      bottom: '15%',
    },
    series: [
      {
        name: 'Saving Median',
        type: 'line',
        data: savingMedian,
        lineStyle: {
          color: '#77AC30',
          width: 1.5,
        },
        showSymbol: false, // Remove symbols (circles) from the line
      },
      {
        name: 'Saving 95% CI',
        type: 'line',
        data: savingLow,
        lineStyle: {
          opacity: 0, // Make the line invisible
        },
        areaStyle: {
          color: 'rgba(70, 186, 48, 0.1)',
        },
        stack: 'confidence-band',
        showSymbol: false, // Remove symbols (circles) from the line
      },
      {
        name: 'Saving 95% CI',
        type: 'line',
        data: savingUp,
        lineStyle: {
          opacity: 0, // Make the line invisible
        },
        areaStyle: {
          color: 'rgba(70, 186, 48, 0.1)',
        },
        stack: 'confidence-band',
        showSymbol: false, // Remove symbols (circles) from the line
      },
      {
        name: 'Least Saving',
        type: 'line',
        data: saving95,
        lineStyle: {
          type: 'dashed',
          color: '#77AC30',
          width: 1.25,
        },
        showSymbol: false, // Remove symbols (circles) from the line
      },
    ],
    legend: {
      data: ['Saving Median', 'Saving 95% CI', 'Least Saving', 'Zero Line'],
      top: '10%',
    },
  };

  return <ReactECharts option={option} style={{ height: '500px', width: '100%' }} />;
};

export default CCSCostFullChart;
